import { Pipe, PipeTransform } from '@angular/core';
import { StudentEksportPaczkaStatus } from '@interfaces/polon/enums/eksporty-polon/eksport-polon-status.enum';

@Pipe({
  name: 'statusEksportu',
})
export class StatusEksportuPipe implements PipeTransform {
  transform(value: StudentEksportPaczkaStatus): string {
    const { WTrakcie } = StudentEksportPaczkaStatus;

    switch (value) {
      case WTrakcie:
        return 'bg-warning';
      default:
        return 'bg-success';
    }
  }
}
